import { Injectable } from '@angular/core';
import { RxHttp } from '@rx/http';
import { Observable } from 'rxjs';
import { AuthorizeApi } from "@rx/security";

@Injectable()
export class ChatService {
	private paramValue: number;


constructor(private http: RxHttp) {}

private get api(): AuthorizeApi {
    var authorizeApi: AuthorizeApi = {
        api: `api/AiChat/`,
        applicationModuleId: 5104,
        keyName: ''
    }
    return authorizeApi;
}

private get startapi(): AuthorizeApi {
  var authorizeApi: AuthorizeApi = {
      api: `api/AiChat/StartNewChat`,
      applicationModuleId: 5104,
      keyName: ''
  }
  return authorizeApi;
}

private get updateTitleApi(): AuthorizeApi {
  var authorizeApi: AuthorizeApi = {
      api: `api/AiChat/UpdateChatTitle`,
      applicationModuleId: 5104,
      keyName: ''
  }
  return authorizeApi;
}

private get deleteApi(): AuthorizeApi {
  var authorizeApi: AuthorizeApi = {
      api: `api/AiChat/${this.paramValue}`,
      applicationModuleId: 5104,
      keyName: ''
  }
  return authorizeApi;
}

getChat(chatId: any): Observable<any> {
  debugger;
    return this.http.get<any>(this.api, {chatId : chatId});
}

sendMessage(message: any): Observable<any> {
  return this.http.post<any>(this.api, message, false);
}

  updateChatTitle(chatId: number, title: string): Observable<any> {
    return this.http.post<any>(this.updateTitleApi, { PositiveAI_ChatId : chatId, Name : title }, false);
  }

  startNewChat(): Observable<any> {
    return this.http.get<any>(this.startapi);
  }

  deleteChat(chatId: number, currentChatId: number): Observable<any> {
    this.paramValue = chatId;
    return this.http.delete<any>(this.deleteApi, currentChatId);
  }

  // Build chat message
  public buildMessage(msg: string, isBot: boolean): HTMLElement {
    const clsList = `ai-chat__message-container ${isBot ? 'ai-chat__message-container--bot mr-auto color-primary' : 'ai-chat__message-container--user ml-auto text-right'}`;
    const msgCont = document.createElement('div');
    msgCont.className = clsList;
    const newMessage = document.createElement('div');
    newMessage.className = 'ai-chat__message text-dark';
    const messageOption = isBot ? '<button><span class="fa fa-ellipsis-h"></span></button>' : '';
    const msgElement = isBot ? `${msg}` : msg;
    newMessage.innerHTML = msgElement;
    msgCont.innerHTML = `${messageOption}${newMessage.outerHTML}`;
    return msgCont;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/ai-chat/ai-chat.service.ts